import CLIENT_CONFIG from './core-config';
import { storage } from 'src/utils/storage';

const DEFAULT_CLIENT = 'WEBWORK_STANDARD';
const STORAGE_KEY = 'activeClient';

// Map site code to client config key
const mapToClientKey = (siteCd) => {
  if (!siteCd) return DEFAULT_CLIENT;
  if (CLIENT_CONFIG[siteCd]) return siteCd;
  
  const upper = siteCd.toUpperCase();
  if (upper.includes('SMCI')) return 'SMCI_CUSTOMIZATION';
  if (upper.includes('SMCD')) return 'SMCD_CUSTOMIZATION';
  if (upper.includes('VISB')) return 'VERMI_CUSTOMIZATION';
  
  return DEFAULT_CLIENT;
};

// Fetch and set active client after login
export const fetchDefaultSiteCode = async () => {
  try {
    const siteCode = storage.get('siteCode');

    if (siteCode) {
      const clientKey = mapToClientKey(siteCode);
      localStorage.setItem(STORAGE_KEY, clientKey);
      return clientKey;
    }
    
    localStorage.setItem(STORAGE_KEY, DEFAULT_CLIENT);
    return DEFAULT_CLIENT;
  } catch (error) {
    console.error('Error fetching default site code:', error);
    localStorage.setItem(STORAGE_KEY, DEFAULT_CLIENT);
    return DEFAULT_CLIENT;
  }
};

// Get current client config
export const getClientConfig = () => {
  // Always derive from siteCode if it exists (source of truth)
  // This ensures consistency even if activeClient is stale
  try {
    const siteCode = storage.get('siteCode');
    if (siteCode) {
      const derivedClientKey = mapToClientKey(siteCode);
      const cachedClientKey = localStorage.getItem(STORAGE_KEY);
      
      // If cached client doesn't match derived client, update cache
      if (cachedClientKey !== derivedClientKey) {
        localStorage.setItem(STORAGE_KEY, derivedClientKey);
      }
      
      return CLIENT_CONFIG[derivedClientKey] || CLIENT_CONFIG[DEFAULT_CLIENT];
    }
  } catch (error) {
    console.error('Error deriving client config from siteCode:', error);
  }
  
  // Fallback to cached activeClient or default
  const clientKey = localStorage.getItem(STORAGE_KEY) || DEFAULT_CLIENT;
  return CLIENT_CONFIG[clientKey] || CLIENT_CONFIG[DEFAULT_CLIENT];
};

// Get active client key
export const getActiveClient = () => {
  // Always derive from siteCode if it exists (source of truth)
  try {
    const siteCode = storage.get('siteCode');
    if (siteCode) {
      const derivedClientKey = mapToClientKey(siteCode);
      const cachedClientKey = localStorage.getItem(STORAGE_KEY);
      
      // If cached client doesn't match derived client, update cache
      if (cachedClientKey !== derivedClientKey) {
        localStorage.setItem(STORAGE_KEY, derivedClientKey);
      }
      
      return derivedClientKey;
    }
  } catch (error) {
    console.error('Error deriving active client from siteCode:', error);
  }
  
  // Fallback to cached activeClient or default
  return localStorage.getItem(STORAGE_KEY) || DEFAULT_CLIENT;
};
